module.exports = __webpack_public_path__ + "img/face18.03e75a5f.jpg";